
// Service Call Cache
const CACHE_V = 'svc_cache_0004';
const LOG = false;

const localStorage = window && window.localStorage ? window.localStorage : null;

// Cache some data in local storage that will expire in some milliseconds (cache_ms)
export const cacheResult = ( cache_key, data, cache_ms ) => {
  if (localStorage) {
    try {
      localStorage.setItem( CACHE_V + cache_key, JSON.stringify({data, expires: +(new Date) + cache_ms}));
    } catch (e) {
      console.warn('local storage cache full', e);
    }
  }
};

// Get data from cache (returns null if data is expired or missing)
export const getCached = ( cache_key ) => {
  const now = +(new Date);
  if (localStorage) {
    try {
      const obj = JSON.parse(localStorage.getItem(CACHE_V + cache_key));
      if (!obj || !obj.data || !obj.expires) {
        LOG &&  console.warn('Cache (' + cache_key + ') - Miss');
        return null;
      }
      const time_left = obj.expires - now;
      if (time_left < 0) {
        LOG && console.warn('Cache (' + cache_key + ') - Expired ' + (-time_left) + 'ms ago');
        return null;
      }
      LOG && console.warn('Cache (' + cache_key + ') - Hit. Expires in ' + time_left + 'ms');
      return obj.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/localCache.js